exports.components = {
  "component---src-pages-404-tsx": () => import("./../../../src/pages/404.tsx" /* webpackChunkName: "component---src-pages-404-tsx" */),
  "component---src-pages-index-tsx": () => import("./../../../src/pages/index.tsx" /* webpackChunkName: "component---src-pages-index-tsx" */),
  "component---src-pages-investor-pulse-nolikums-tsx": () => import("./../../../src/pages/investor-pulse-nolikums.tsx" /* webpackChunkName: "component---src-pages-investor-pulse-nolikums-tsx" */),
  "component---src-pages-sikdatnu-politika-tsx": () => import("./../../../src/pages/sikdatnu-politika.tsx" /* webpackChunkName: "component---src-pages-sikdatnu-politika-tsx" */)
}

